var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-responsive',{attrs:{"aspect-ratio":16/9}},[_c('svg',{attrs:{"id":"good3-svg-parangonHistory","height":"100%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }